export const adform = {
  state: {
    adformCredentialAsked: false,
    adformCredentialCreated: false,
    adformCredentialError: false,
    adformCredentialErrorMsg: null,
    adformPublishSettings: false,
    adformAdvertisers: [],
    adformAdvertiserId: null,
    adformCampaigns: [],
    adformCampaignId: null,
    adformName: '{{campaign_name}} {{size_format}}',
    adformPublishType: null,
    adformPoliteLoad: false,
  },
  reducers: {
    setAdformCredentialAsked(state, action) {
      state.adformCredentialAsked = action.payload;
    },
    setAdformCredentialCreated(state, action) {
      state.adformCredentialCreated = action.payload;
    },
    setAdformCredentialError(state, action) {
      state.adformCredentialError = true;
      state.adformCredentialErrorMsg = action.payload;
    },
    resetAdformCredentialError(state, action) {
      state.adformCredentialError = false;
      state.adformCredentialErrorMsg = null;
    }, 
    setAdformPublishSettings(state, action) {
      state.adformPublishSettings = action.payload;
    },
    setAdformAdvertisers(state, action) {
      state.adformAdvertisers = action.payload;
    },
    setAdformAdvertiserId(state, action) {
      state.adformAdvertiserId = action.payload;
    },
    setAdformCampaigns(state, action) {
      state.adformCampaigns = action.payload;
    },
    setAdformCampaignId(state, action) {
      state.adformCampaignId = action.payload;
    },
    setAdformName(state, action) {
      state.adformName = action.payload;
    },
    setAdformPublishType(state, action) {
      state.adformPublishType = action.payload;
    },
    setAdformPoliteLoad(state, action) {
      state.adformPoliteLoad = action.payload;
    },
    resetAdformState(state, action) {
      state.adformCredentialAsked; false;
      state.adformCredentialCreated; false;
      state.adformCredentialError; false;
      state.adformCredentialErrorMsg; null;
      state.adformPublishSettings; false;
      state.adformAdvertisers; [];
      state.adformAdvertiserId; null;
      state.adformCampaigns; [];
      state.adformCampaignId; null;
      state.adformName; '{{campaign_name}} {{size_format}}';
      state.adformPublishType; null;
      state.adformPoliteLoad; false;
    }
  },
  getExtraReducers: (builder) => {
    return null;
  }
}